import React from 'react'
import PropTypes from 'prop-types'

import { Spinner } from 'ui'
import { t } from 'translations'

const TableButton = ({ children, className, disabled, isSubmitting, onClick, text, type, row, ...props }) => {
  return (
    <button {...props} type={type} className={className} onClick={onClick} disabled={disabled || isSubmitting}>
      {isSubmitting ? (
        <span>
          <Spinner className="mr-2" />
        </span>
      ) : null}
      {t(text)}
      {typeof children === 'function' ? children(row) : children}
    </button>
  )
}

export default TableButton

// Set the proptypes for validation
TableButton.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  row: PropTypes.object
}
TableButton.defaultProps = {
  className: 'btn btn-primary',
  text: '',
  type: 'button',
  disabled: false
}
